
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const PageHeader = (props) => {

  return (
    <div className=''>
      <div className="page-header">
        <div>
        <h1 className="page-title">{props.titles}</h1>
          <Breadcrumb>
              {props.items.map((value, index) => {
                return <Breadcrumb.Item key={index} className="breadcrumb-item">
                     <div to="#" >{value}</div>
                  </Breadcrumb.Item>
              })}
            <Breadcrumb.Item className="breadcrumb-item active" aria-current="page">{props.active}</Breadcrumb.Item>
          </Breadcrumb>
          </div>
        </div>
    </div>
  )
};

export default PageHeader;
